// extracted by mini-css-extract-plugin
export default {"modals":"styles_modals__6aB00","modal-template":"styles_modal-template__Bxc7y"};